import { FeedRidContext, LiveFeedContext } from "@finbackoffice/site-core";
import { useSocketStorage } from "hooks/base";
import { Params } from "next/dist/server/request/params";
import { useParams } from "next/navigation";
import { useContext } from "react";

export type ISelectedLiveParams = {
    sportSlug: string;
    categoryId: number;
    gameId: number;
};

function getDefaultLiveParamsFromUrl(params: Params): ISelectedLiveParams {
    const [sport, categoryId, gameId] = params.liveGameRoutes ?? [];

    return {
        sportSlug: (sport as string) || (params.sport as string),
        categoryId: parseInt(categoryId as string),
        gameId: parseInt(gameId as string),
    };
}

export const useSelectedLiveGameId = (): number | null => {
    const { hasLiveFeedGames } = useContext(LiveFeedContext);
    const { liveRid } = useContext(FeedRidContext);
    const { getEvent } = useSocketStorage(liveRid);
    const params = useParams();
    const { gameId } = getDefaultLiveParamsFromUrl(params);

    if (!hasLiveFeedGames) {
        return null;
    }

    return getEvent(gameId)?.id ?? null;
};

export const useDefaultLiveParamsFromUrl = (): ISelectedLiveParams => {
    const params = useParams();
    const defaultUrlParams = getDefaultLiveParamsFromUrl(params);

    return defaultUrlParams;
};
